import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import service from '@/services';
import useCommonStore from '@/stores/pure/CommonStore';

import useWorkspaceRouter from '../useWorkspaceRouter';

type UseAppLogoutOptions = {
  onAfterLocalLogout?: () => void;
};

const useAppLogout = (options: UseAppLogoutOptions = {}) => {
  const { onAfterLocalLogout } = options;
  const { isAuthenticated: isOktaAuthenticated, logout: logoutFromOkta } =
    useAuth0();
  const { navigate } = useWorkspaceRouter();
  const initWholeStore = useCommonStore((state) => state.initWholeStore);

  return useCallback(async () => {
    await service.auth.logout();
    initWholeStore();
    onAfterLocalLogout?.();

    if (isOktaAuthenticated) {
      await logoutFromOkta({
        logoutParams: { returnTo: window.location.origin },
      });
      return;
    }

    navigate('/login', {
      replace: true,
    });
  }, [
    initWholeStore,
    isOktaAuthenticated,
    logoutFromOkta,
    navigate,
    onAfterLocalLogout,
  ]);
};

export default useAppLogout;
